
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class WPLayoutBorder extends Vue {
  @Prop({ default: false })
  public readonly loading?: boolean
}
